import PubSub from "underpub-js";

var CardUnit = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-CardUnit',
	};

	$.extend(true, this.options, options);

};

CardUnit.prototype.init = function() {

	var self = this;

};

export default CardUnit;
